module.exports = __webpack_public_path__ + "img/MCD_Kontakt_Quart_Teaser_Neumann_01.4b2887fa.jpg";